import { Component, computed, inject, output, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PanModalComponent } from '../../components/pan-modal/pan-modal.component';
import { UiModule } from '../../components/ui.module';
import { NotifyService } from '../../service/notify.service';
import { UserAdminService } from '../../service/user-admin.service';
import { UserProfile } from '../../types';

@Component({
  selector: 'app-admin-user-management-create-user',
  imports: [FormsModule, UiModule],
  templateUrl: './admin-user-management-create-user.component.html',
  styleUrl: './admin-user-management-create-user.component.scss',
})
export class AdminUserManagementCreateUserComponent {
  private userAdmin = inject(UserAdminService);
  private notifications = inject(NotifyService);

  public newUserEmail = signal<string>('');
  public newUserName = signal<string>('');
  public canAddNewUser = computed(() => this.newUserName().trim() && this.newUserEmail().trim());
  public submittingNewUser = signal<boolean>(false);

  public modal = viewChild<PanModalComponent>('addModal');

  public createdUser = output<UserProfile>();

  public addNewUser() {
    this.submittingNewUser.set(true);
    this.userAdmin.createUser(this.newUserName().trim(), this.newUserEmail().trim()).subscribe(
      (d) => {
        this.createdUser.emit(d);
        this.submittingNewUser.set(false);

        this.newUserEmail.set('');
        this.newUserName.set('');
      },
      () => {
        this.notifications.notify('Could not add user.');
        this.submittingNewUser.set(false);
      },
    );
  }

  public cleanUsername() {
    const cleanUsername = this.newUserName().replace(/[^a-zA-Z ]/gi, '');
    this.newUserName.set(cleanUsername);
  }

  public clearInputs() {
    this.newUserEmail.set('');
    this.newUserName.set('');
  }

  public show() {
    this.modal().show();
  }

  public hide() {
    this.modal().hide();
  }
}
